import styled from 'styled-components';

// TODO: Make this use Typography
export const Label = styled.label`
  display: block;
  color: ${({ theme }) => theme.palette.text.onSurface.strong};
  margin-bottom: ${({ theme }) => theme.spacing(1)};
  font-size: 18px;
  line-height: 28px;
  font-family: ShellHeavy;
`;
